import { is } from "app/pages/sales-intelligence/utils/type-guards";

import type { IRelativeDateRange } from "../range";

export const isRelativeDateRangeValue = (value: unknown): value is IRelativeDateRange =>
    is.record(value) && is.string(value.range) && is.string(value.rangeType);

export const isNumberRangeValue = (
    value: unknown,
): value is { readonly from?: number | null; readonly to?: number | null } =>
    is.record(value) &&
    is.number(value.from ?? value.to) &&
    (value.from == null || is.number(value.from)) &&
    (value.to == null || is.number(value.to));
